<template>
    <div>
        <v-list-item
            v-if="item.takeInChargeOption"
            @click="takeInCharge"
        >
            <v-list-item-icon>
                <v-icon v-text="'mdi-car-cruise-control'" color="teal"></v-icon>
            </v-list-item-icon>
            <v-list-item-title>
                {{ $t("common.take_in_charge") }}
            </v-list-item-title>
        </v-list-item>

        <v-list-item
            v-if="item.validateOption && !item.takeInChargeOption"
            @click="setDecision"
        >
            <v-list-item-icon>
                <v-icon v-text="'mdi-check-decagram'" color="deep-orange"></v-icon>
            </v-list-item-icon>
            <v-list-item-title>
                {{ $t("common.set_decision") }}
            </v-list-item-title>
        </v-list-item>

        <v-list-item @click="viewHistory">
            <v-list-item-icon>
                <v-icon
                    v-text="'mdi-chart-timeline'"
                    color="blue"
                ></v-icon>
            </v-list-item-icon>
            <v-list-item-title>
                {{ $t("recruitment_request.validation_history") }}
            </v-list-item-title>
        </v-list-item>
    </div>
</template>

<script>

import useTools from "@/use/Tools";

export default {
    name: "WMenuValidationAction",
    props: {
        item: Object,
        rootPath: String,
        module: String,
    },
    emits: ["takeInCharge", "setDecision", "viewHistory"],
    setup(props, { emit }) {
        const {$router} = useTools();


        function takeInCharge() {
            $router.push({ name: `${props.rootPath}.take_in_charge`, params: { id: props.item.id, module: props.module}})
            emit("takeInCharge");
        }

        function setDecision() {
            $router.push({ name: `${props.rootPath}.set_decision`, params: { id: props.item.id, module: props.module}})
            emit("setDecision");
        }

        function viewHistory() {
            $router.push({ name: `${props.rootPath}.timelines`, params: { id: props.item.id, module: props.module}})
            emit("viewHistory");
        }

        return {
            takeInCharge,
            setDecision,
            viewHistory,
        }
    }
}
</script>

<style scoped>

</style>